import '../../../theme/partials/_status.scss';

import {
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonImg,
  IonInput,
  IonItemDivider,
  IonLabel,
  IonLoading,
  IonModal,
  IonPage,
  IonRow,
  IonSegment,
  IonSegmentButton,
  IonText,
  IonToolbar,
  useIonViewDidEnter,
  useIonViewDidLeave,
} from '@ionic/react';
import classNames from 'classnames';
import {
  addCircle,
  chevronBackOutline,
  closeOutline,
  helpCircleOutline,
  informationCircleOutline,
} from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
// Referencias para los inputs
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import CaretLeftIcon from '@/assets/icons/keyboard-arrow-left.svg';
import Pending from '@/assets/icons/pending.webp';
import WarningIcon from '@/assets/icons/warning.svg';
import Finish from '@/assets/imgs/finish.svg';
import Button from '@/components/common/Button';
import { ROUTES_PATH } from '@/constants';
import { RefundType } from '@/entities/operationStatus';
import useMediaQuery, { Breakpoint } from '@/hooks/useMediaQuery';
import { ClientTaxonomyEvents } from '@/interfaces/AnalyticsInterface/AnalyticsInterface';
import {
  InitialStatus,
  Name,
} from '@/interfaces/OperationsDashboardInterface/OperationsDashboardInterface';
import {
  errorCodeRefund,
  messageGEN0001,
  messageGEN0003,
  messageLOA0004,
  messageLOA0005,
  messageLOA0011,
  messageLOA0032,
  messageLOA0033,
  RefundSimulation,
} from '@/interfaces/RefunfInterface/RefundInterface';
import { getDashboards } from '@/redux/operation/operationsAPI';
import {
  postLoanRefunds, postOrderRefunds, postSimulateLoanRefunds, postSimulateOrderRefunds,
} from '@/redux/retaken/retakenAPI';
import { Analytics } from '@/services/analytics';
import { RootState } from '@/store';
import { getCustomerFullName } from '@/utils/customerHelper';
import { getTodayDate } from '@/utils/dateHelper';
import { pricesHelper } from '@/utils/pricesHelper';

import styles from './OperationRefund.module.scss';

const REFUND_GENERIC_ERROR = 'Se ha producido un error. Vuelva a intentarlo más tarde';

export default function OperationRefund() {
  const history = useHistory();
  const location = useLocation();
  // const [changeScreen, setChangeScreen] = useState<boolean>(false);
  const [additionalBills, setAdditionalBills] = useState<boolean>(false);
  const [openInfoModal, setOpenInfoModal] = useState<boolean>(false);
  const [openFinishModal, setOpenFinishModal] = useState<boolean>(false);
  const [optionBills, setOptionBills] = useState<string>();
  const imageRef = useRef<HTMLIonImgElement>(null);
  const buttonRef = useRef<HTMLIonButtonElement>(null);
  const [amount, setAmount] = useState<number | null>(null);
  const [product, setProduct] = useState<any>({
    customer_expenses: 0,
    type: 'TOTAL',
  });
  const operationData: any = useSelector((state: RootState) => state.operation);
  const [commercialOffer, setCommercialOffer] = useState<any>(
    operationData?.data?.data,
  );
  const [printErrorMessage, setPrintErrorMessage] = useState<any>('');
  // Error de la última simulación total: se restaura al volver a la pestaña de
  // devolución total para que el botón siga bloqueado
  const [totalSimulationError, setTotalSimulationError] = useState<string>('');
  // Error al confirmar la devolución: se muestra en el modal de confirmación
  const [confirmRefundError, setConfirmRefundError] = useState<string>('');
  const {
    LOA0004, GEN0003, GEN0001, LOA0005, LOA0011, LOA0032, LOA0033,
  } = errorCodeRefund;
  const [openRefundModal, setOpenRefundModal] = useState<boolean>(false);
  const [openSummaryModal, setOpenSummaryModal] = useState<boolean>(false);
  const [refundData, setRefundData] = useState<RefundSimulation | null>(null);
  const [totalRefund, setTotalRefund] = useState<RefundSimulation | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [refundMethod, setRefundMethod] = useState<RefundType>(RefundType.Total);
  const [unprocessable, setUnprocessable] = useState<boolean>(false);
  const queryParams = new URLSearchParams(location.search);
  const creditProposalID = queryParams.get('credit_proposal_id');
  const cartID = queryParams.get('cart_id');
  const calculatingMaxRefund = useRef<boolean>(false);
  const componentMounted = useRef<boolean>(true);

  const isDesktop = useMediaQuery(Breakpoint.Tablet);

  // Referencias para los inputs y los títulos de sección
  const totalInputRef = useRef<HTMLIonInputElement>(null);
  const partialInputRef = useRef<HTMLIonInputElement>(null);
  const ionContentRef = useRef<HTMLIonContentElement>(null);
  const partialTitleRef = useRef<HTMLIonLabelElement>(null);
  const gastosTitleRef = useRef<HTMLIonLabelElement>(null);

  // Handler para hacer scroll al título de la sección correspondiente
  const scrollToTitle = (titleRef: React.RefObject<HTMLIonLabelElement>) => {
    if (titleRef.current && ionContentRef.current) {
      const contentEl = (ionContentRef.current as any).el;
      const contentRect = contentEl.getBoundingClientRect();
      const titleRect = titleRef.current.getBoundingClientRect();
      const fixedButtonHeight = !isDesktop ? 90 : 0;
      const extraOffset = 16;
      const y = titleRect.top - contentRect.top + contentEl.scrollTop - fixedButtonHeight - extraOffset;
      (ionContentRef.current as any).scrollToPoint(0, y, 500);
    }
  };

  const selectProduct = (price: string) => {
    if (price) {
      setAmount(Number(price));
      let productObj;
      if (refundMethod === RefundType.Total) {
        productObj = {
          customer_expenses: Number(price),
          type: 'TOTAL',
        };
      } else {
        productObj = {
          amount: Number(price),
          type: 'PARTIAL',
        };
      }
      setProduct(productObj);
      retaken(productObj);
    } else {
      setAmount(null);
    }
  };

  const getRefundMax = () => {
    let maxNumb;
    if (commercialOffer?.order) {
      maxNumb = (
        commercialOffer?.order?.total_refunded
          ? commercialOffer.order.total_price
          - commercialOffer.order.total_refunded
          : commercialOffer.order.total_price
      ).toString();
    } else if (commercialOffer?.business_status === InitialStatus.DevParcial) {
      maxNumb = (commercialOffer.loan.requested_amount - commercialOffer.loan.total_refunded).toString();
    } else {
      maxNumb = commercialOffer.loan.requested_amount.toString();
    }
    return maxNumb.replace(/\./g, ',');
  };

  // Traduce el error de las llamadas de simulación y de devolución a un mensaje para el usuario
  const getRefundErrorMessage = (err: any): string => {
    const error = err?.result?.errors?.[0];
    switch (error?.code) {
      case LOA0004:
        return `${messageLOA0004}${getRefundMax()}`;
      case LOA0005: {
        const allowAmount = error.message?.split('\'')[3]?.replace(/\./g, ',') ?? '';
        return `${messageLOA0005}${allowAmount} `;
      }
      case LOA0011:
        return messageLOA0011;
      case LOA0032:
        return messageLOA0032;
      case LOA0033:
        return messageLOA0033;
      case GEN0001:
        return messageGEN0001;
      case GEN0003:
        return messageGEN0003;
      default:
        return REFUND_GENERIC_ERROR;
    }
  };

  const retaken = async (productObj?: any) => {
    if (componentMounted.current) {
      const isTotalSimulation = (productObj ?? product).type === 'TOTAL';
      try {
        const refundSimulation = commercialOffer.order
          ? await postSimulateOrderRefunds(
            commercialOffer.order.order_id,
            productObj ?? product,
          )
          : await postSimulateLoanRefunds(
            commercialOffer?.loan?.loan_id,
            productObj ?? product,
          );
        calculatingMaxRefund.current = false;
        setRefundData(refundSimulation.data);
        setPrintErrorMessage('');
        if (isTotalSimulation) {
          setTotalSimulationError('');
        }
        Analytics.registerAnalyticsEvent({
          [ClientTaxonomyEvents.REFUND_SIMULATION]: {
            type: refundSimulation?.type || '',
            amount: refundSimulation?.amount || '',
          },
        });
        refundMethod === RefundType.Total && !totalRefund && setTotalRefund(refundSimulation.data);
      } catch (err: any) {
        calculatingMaxRefund.current = false;
        const errorMessage = getRefundErrorMessage(err);
        setPrintErrorMessage(errorMessage);
        if (isTotalSimulation) {
          setTotalSimulationError(errorMessage);
        }
      }
    }
  };

  const handleImageClick = () => {
    const idValue = imageRef.current?.id;
    setOptionBills(idValue);
    setOpenInfoModal(true);
  };

  const changeName = (name: string) => {
    const {
      PAI, WTD, TRF, PRF, NRF, APP, CAP, NTP, EXP, TUD, RTK,
    } = Name;
    const {
      Abonada,
      Denegada,
      DevTotal,
      DevParcial,
      PteDevolucion,
      Aprobada,
      Captura,
      PteDesembolso,
      Caducada,
      Rechazada,
      Retomada,
    } = InitialStatus;
    switch (name) {
      case Denegada:
        return WTD;
      case Abonada:
        return PAI;
      case DevTotal:
        return TRF;
      case DevParcial:
        return PRF;
      case PteDevolucion:
        return NRF;
      case Aprobada:
        return APP;
      case Captura:
        return CAP;
      case PteDesembolso:
        return NTP;
      case Caducada:
        return EXP;
      case Rechazada:
        return TUD;
      case Retomada:
        return RTK;
      default:
        break;
    }
  };

  const handleDelete = () => {
    setAmount(null);
    setPrintErrorMessage('');
  };

  const handleConfirmRefund = async () => {
    try {
      setIsLoading(true);
      setConfirmRefundError('');
      const buttonID = buttonRef.current?.id;
      let http_result;
      if (buttonID === 'total') {
        if (commercialOffer?.order?.order_id) {
          http_result = await postOrderRefunds(
            commercialOffer?.order?.order_id,
            {
              type: buttonID.toUpperCase(),
              customer_expenses: Number(amount),
            },
          );
        } else {
          http_result = await postLoanRefunds(commercialOffer?.loan?.loan_id, {
            type: buttonID.toUpperCase(),
            customer_expenses: Number(amount),
          });
        }
      }

      if (buttonID === 'partial') {
        if (commercialOffer?.order?.order_id) {
          http_result = await postOrderRefunds(
            commercialOffer?.order?.order_id,
            {
              type: buttonID.toUpperCase(),
              amount: Number(amount),
            },
          );
        } else {
          http_result = await postLoanRefunds(commercialOffer?.loan?.loan_id, {
            type: buttonID.toUpperCase(),
            amount: Number(amount),
          });
        }
      }
      if (http_result?.result?.http_code === 200) {
        Analytics.registerAnalyticsEvent({
          [ClientTaxonomyEvents.REFUND_CONFIRMATION]: {
            type: buttonID || '',
            amount: Number(amount) || '',
          },
        });
        setIsLoading(false);
        setOpenRefundModal(false);
        setOpenFinishModal(true);
      } else {
        // Sin respuesta válida (p. ej. un 500 tras el reintento del interceptor): se
        // mantiene el modal abierto con el error en lugar de cerrarlo sin avisar
        setIsLoading(false);
        setConfirmRefundError(REFUND_GENERIC_ERROR);
      }
    } catch (err: any) {
      setIsLoading(false);
      setConfirmRefundError(getRefundErrorMessage(err));
    }
  };

  const reloadPage = async () => {
    try {
      let newFilterValues;
      if (cartID) {
        newFilterValues = {
          offset: 0,
          limit: 20,
          nameOrDni: '',
          cart_id: `&cart_id=${cartID}`,
          from_date: '',
          to_date: '',
          buttons: '',
        };
      } else if (creditProposalID) {
        newFilterValues = {
          offset: 0,
          limit: 20,
          nameOrDni: '',
          cart_id: '',
          credit_proposal_id: creditProposalID,
          from_date: '',
          to_date: '',
          buttons: '',
        };
      }
      if (newFilterValues) {
        const dashboardApiResponse = await getDashboards(newFilterValues);
        const newCommercialOffer = dashboardApiResponse.data.dashboards[0];
        setCommercialOffer(newCommercialOffer);
        setIsLoading(false);
      }
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (operationData && operationData.data && operationData.data.data) {
      setCommercialOffer(operationData.data.data);
    }
  }, [operationData]);

  useEffect(() => { }, [
    optionBills,
    openInfoModal,
    openRefundModal,
    openFinishModal,
  ]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [window.innerWidth]);

  // Simula la devolución al entrar en la página, una vez por visita y operación. Ionic
  // mantiene la página montada entre navegaciones, así que al volver a entrar no basta
  // con el efecto de commercialOffer y también se lanza desde useIonViewDidEnter
  const simulatedOffer = useRef<any>(null);
  const simulateOnEnter = () => {
    if (
      !componentMounted.current
      || !commercialOffer
      || simulatedOffer.current === commercialOffer
    ) {
      return;
    }
    simulatedOffer.current = commercialOffer;
    if (refundMethod === RefundType.Total && commercialOffer?.loan?.refunds) {
      const todayDate = getTodayDate();
      const canTotalRefund = commercialOffer?.loan?.refunds.find((refund: any) => refund.created_date === todayDate);
      setUnprocessable(canTotalRefund);
    } else {
      setUnprocessable(false);
    }
    retaken();
  };
  // Los hooks de ciclo de vida de Ionic se registran una sola vez: se llama a la última versión
  const simulateOnEnterRef = useRef(simulateOnEnter);
  simulateOnEnterRef.current = simulateOnEnter;

  useEffect(() => {
    if (
      commercialOffer
    ) {
      simulateOnEnter();
    } else {
      reloadPage();
    }
  }, [commercialOffer]);

  // Los métodos useIonViewDidEnter y useIonViewDidLeave controlan que se lance la simulación
  // solo si el componente es visible para el usuario. Se podrán eliminar cuando el componente
  // se desmonte correctamente después de recargar la página en el navegador.
  useIonViewDidEnter(() => {
    componentMounted.current = true;
    simulateOnEnterRef.current();
  });

  useIonViewDidLeave(() => {
    componentMounted.current = false;
    simulatedOffer.current = null;
  });

  return (
    <IonPage className={styles.operationsRefundPage}>
      <IonContent ref={ionContentRef} className={styles.operationsRefundPageContent}>
        <div
          className={classNames(
            styles.pageOperationsRefund,
            isLoading && styles.loadingOverlay,
          )}
        >
          <div className={styles.pageOperationsReturnContainer}>
            <IonIcon
              slot="start"
              icon={chevronBackOutline}
              className={styles.iconBtn}
            />
            <IonButton
              onClick={() => history.push(
                commercialOffer?.order
                  ? `${ROUTES_PATH.OPERATION_DASHBOARD_DETAIL}?cart_id=${cartID}`
                  : `${ROUTES_PATH.OPERATION_DASHBOARD_DETAIL}?credit_proposal_id=${creditProposalID}`,
              )}
              fill="clear"
              className={styles.btnBack}
            >
              Volver a la operación
            </IonButton>
          </div>
          <div className={styles.pageOperationsRefundCard}>
            <IonCard className={styles.operationsRefundCardContainer}>
              <IonCardHeader className={styles.operationsRefundCardHeader}>
                <IonCardSubtitle className={styles.operationsRefundCardHeaderTitle}>
                  <IonIcon
                    src={CaretLeftIcon}
                    className={styles.returnMobile}
                    onClick={() => history.push(
                      commercialOffer?.order
                        ? `${ROUTES_PATH.OPERATION_DASHBOARD_DETAIL}?cart_id=${cartID}`
                        : `${ROUTES_PATH.OPERATION_DASHBOARD_DETAIL}?credit_proposal_id=${creditProposalID}`,
                    )}
                  />
                  <span className={styles.operationsRefundCardHeaderTitleDni}>
                    {commercialOffer?.customer?.document_id}
                  </span>
                  {screenWidth > 501 && (
                    <span className={styles.operationsRefundCardHeaderTitleSlash}>
                      |
                    </span>
                  )}
                  <span className={styles.operationsRefundCardHeaderTitleName}>
                    {getCustomerFullName(commercialOffer?.customer)}
                  </span>
                </IonCardSubtitle>
                <IonCardSubtitle className={styles.operationsRefundCardHeaderSubtitle}>
                  <IonLabel
                    className={classNames(
                      styles.targetStatusLabel,
                      changeName(commercialOffer?.business_status),
                    )}
                  >
                    {changeName(commercialOffer?.business_status)}
                  </IonLabel>
                </IonCardSubtitle>
              </IonCardHeader>
              <IonCardContent className={styles.cardContent}>
                <div className={styles.operationsHeaderContainer}>

                  <div className={styles.operationsRefundCardContent}>
                    <div className={styles.operationsRefundCardContentTitle}>
                      <IonText className={styles.contentTitle}>
                        Devolución de pedido
                      </IonText>
                    </div>
                    <div className={styles.operationsRefundCardContentAmount}>
                      <IonText className={styles.operationsRefundCardContentAmountTitle}>
                        Importe total de la compra:
                      </IonText>
                      <IonText className={styles.operationsRefundCardContentAmountPrice}>
                        {pricesHelper(
                          commercialOffer?.proposal?.requested_amount,
                        )}
                      </IonText>
                    </div>
                  </div>
                  <div className={styles.headerDivider} />
                  <div id="refunds-segments-container" className={styles.segmentsContainer}>
                    <IonSegment
                      mode="ios"
                      value={refundMethod}
                      onIonChange={(event: any) => {
                        setAmount(null);
                        setPrintErrorMessage(event.detail.value === RefundType.Total ? totalSimulationError : '');
                        setRefundMethod(event.detail.value);
                      }}
                      className={styles.operationsDetailSegment}
                    >
                      <IonSegmentButton value={RefundType.Total}>
                        <IonLabel>Devolución total</IonLabel>
                      </IonSegmentButton>
                      <IonSegmentButton value={RefundType.Partial}>
                        <IonLabel>Devolución parcial</IonLabel>
                      </IonSegmentButton>
                    </IonSegment>
                  </div>
                </div>

                <div className={styles.operationsRefundCard}>
                  <div className={styles.operationsRefundCardDetailInfo}>
                    <div className={styles.operationsRefundCardDetailInfoTotal}>
                      <IonLabel className={styles.refundInfoTotalTitle}>
                        {refundMethod === RefundType.Total
                          ? 'Devolución total del pedido'
                          : 'Devolución parcial del pedido'}
                      </IonLabel>
                      <IonImg
                        ref={imageRef}
                        src={Pending}
                        className={styles.refundInfoTotalIcon}
                        id={refundMethod === RefundType.Total ? 'total' : 'partial'}
                        onClick={handleImageClick}
                      />
                      <IonModal
                        isOpen={openInfoModal}
                        onDidDismiss={() => setOpenInfoModal(false)}
                        className={
                          classNames(
                            styles.infoModalRefund,
                            isLoading
                              ? styles.loadingOverlay
                              : '',
                          )
                        }
                      >
                        <IonHeader className={styles.infomodalHeader}>
                          <IonToolbar className={styles.infomodalToolbar}>
                            <IonButtons slot="end">
                              <IonButton
                                onClick={() => setOpenInfoModal(false)}
                              >
                                <IonIcon md={closeOutline} />
                              </IonButton>
                            </IonButtons>
                          </IonToolbar>
                        </IonHeader>
                        {optionBills === 'total' ? (
                          <IonContent>
                            <div className={styles.itemTotalPartial}>
                              <IonIcon
                                md={helpCircleOutline}
                                className={styles.itemTotalPartialIcon}
                              />
                              <IonLabel className={styles.itemTotalPartialTitle}>
                                ¿Cuándo realizar la devolución total?
                              </IonLabel>
                              <IonText className={styles.itemTotalPartialText}>
                                Si el cliente quiere cancelar la compra de su
                                pedido y devolver todos los productos adquiridos
                              </IonText>
                              <IonText className={styles.itemTotalPartialText}>
                                En caso de tener gastos por gestión, se debe
                                indicar el importe que será retenido en "Añadir
                                gastos adicionales".
                              </IonText>
                            </div>
                          </IonContent>
                        ) : (
                          <IonContent>
                            <div className={styles.itemTotalPartial}>
                              <IonIcon
                                md={helpCircleOutline}
                                className={styles.itemTotalPartialIcon}
                              />
                              <IonLabel className={styles.itemTotalPartialTitle}>
                                ¿Cuándo realizar la devolución parcial?
                              </IonLabel>
                              <IonText className={styles.itemTotalPartialText}>
                                Cuando el cliente quiere devolver uno de los
                                artículos de la compra total.
                              </IonText>
                              <IonText className={styles.itemTotalPartialText}>
                                Se debe introducir el importe manualmente y
                                añadir gastos adicionales si aplica.
                              </IonText>
                            </div>
                          </IonContent>
                        )}
                      </IonModal>
                    </div>
                  </div>

                  {refundMethod === RefundType.Total ? (
                    <div className={styles.operationRefundContentInfo}>
                      {commercialOffer?.order && (
                        <>
                          {!additionalBills ? (
                            <div
                              className={styles.operationRefundContentInfoPrincipal}
                              onClick={() => setAdditionalBills(!additionalBills)}
                            >
                              <IonIcon
                                md={addCircle}
                                className={styles.iconAddCircle}
                              />
                              <IonText className={styles.infoPrincipalText}>
                                Añadir gastos adicionales
                              </IonText>
                            </div>
                          ) : (
                            <div className={styles.operationRefundContentAditionalsBills}>
                              <div className={styles.operationRefundContentAditionalsBillsText}>
                                <IonLabel ref={gastosTitleRef} className={styles.operationRefundContentAditionalsBillsTextTitle}>
                                  Gastos adicionales
                                </IonLabel>
                                <IonText className={styles.operationRefundContentAditionalsBillsTextSubtitle}>
                                  Recogida de mercancía, montaje...
                                </IonText>
                                {printErrorMessage && (
                                  <IonText className={styles.errorMessage}>
                                    {printErrorMessage}
                                  </IonText>
                                )}
                              </div>
                              <div className={styles.operationRefundContentAditionalAmounts}>

                                <div className={styles.operationRefundContentAditionalBillsResult}>
                                  <IonInput
                                    ref={totalInputRef}
                                    className={styles.operationRefundContentAditionalBillsResultAmount}
                                    placeholder="0,00"
                                    inputMode="numeric"
                                    type="number"
                                    value={amount?.toString()}
                                    onIonInput={(e: any) => selectProduct(e.target.value)}
                                    step="0.01"
                                    labelPlacement="stacked"
                                    onFocus={() => scrollToTitle(gastosTitleRef)}
                                  >
                                    <div slot="label">
                                      Cantidad
                                    </div>
                                    <IonText className={styles.operationRefundContentAditionalBillsResultSymbol} />
                                    <IonLabel slot="end">€</IonLabel>
                                  </IonInput>
                                </div>
                                {amount !== null
                                  && (
                                  <IonButton
                                    className={
                                      classNames(
                                        styles.aditionalBillsDelete,
                                        amount
                                          ? styles.aditionalBillsDeleteActivate
                                          : '',
                                      )
                                    }
                                    disabled={!!(amount && amount < 0)}
                                    onClick={() => handleDelete()}
                                  >
                                    Borrar
                                  </IonButton>
                                  )}
                              </div>
                            </div>
                          )}
                          <div className={styles.operationRefundContentInfoSecondary}>
                            <IonIcon
                              src={WarningIcon}
                              className={styles.iconInfo}
                            />
                            <IonText className={styles.operationRefundContentInfoSecondaryTitle}>
                              ¡Atención! Los gastos se restarán al cliente de la
                              cantidad a devolver
                            </IonText>
                          </div>
                        </>
                      )}
                      {commercialOffer?.order && <IonItemDivider className={styles.dividerPartialTotal} />}

                      {!unprocessable
                        ? (
                          <div className={styles.operationsRefundContentResult}>
                            <IonLabel className={styles.operationsRefundContentResultTitle}>
                              Importe final de la devolución:
                              {' '}
                            </IonLabel>
                            <IonLabel className={styles.operationsRefundContentResultAmount}>
                              {totalRefund
                              && pricesHelper(
                                totalRefund?.amount,
                              )}
                            </IonLabel>
                          </div>
                        )
                        : (
                          <div className={styles.operationRefundContentInfoSecondary}>
                            <IonIcon
                              md={informationCircleOutline}
                              className={styles.iconInfo}
                            />
                            <IonText className={styles.operationRefundContentInfoSecondaryTitle}>
                              {messageLOA0033}
                            </IonText>
                          </div>
                        )}
                    </div>
                  ) : (
                    <div className={classNames(styles.operationRefundContentInfoPartial, printErrorMessage && styles.operationRefundContentInfoPartialError)}>
                      <div className={styles.operationRefundContentInfoPartialContent}>
                        <div className={styles.operationRefundContentAditionalsBills}>
                          <IonLabel
                            ref={partialTitleRef}
                            className={styles.operationRefundContentAditionalsBillsTextTitleSecond}
                          >
                            Introduce la cantidad a devolver
                          </IonLabel>
                        </div>
                        <div className={styles.operationPartialsRefund}>
                          <div className={styles.operationRefundAmountPartial}>
                            <IonInput
                              ref={partialInputRef}
                              className={styles.operationRefundContentAditionalBillsResultPrice}
                              placeholder="0,00"
                              inputMode="numeric"
                              type="number"
                              value={amount}
                              onIonInput={(e: any) => selectProduct(e.target.value)}
                              step="0.01"
                              labelPlacement="stacked"
                              onFocus={() => scrollToTitle(partialTitleRef)}
                            >
                              <div slot="label">
                                Cantidad
                              </div>
                              <IonText className={styles.operationRefundContentAditionalBillsResultSymbol} />
                              <IonLabel slot="end">€</IonLabel>
                            </IonInput>
                          </div>
                          <IonButton
                            className={
                              classNames(
                                styles.aditionalBillsDelete,
                                amount && amount >= 0
                                  ? styles.aditionalBillsDeleteActivate
                                  : '',
                              )
                            }
                            disabled={!!(amount && amount < 0)}
                            onClick={() => handleDelete()}
                          >
                            Borrar
                          </IonButton>
                        </div>
                      </div>
                      {printErrorMessage && (
                        <IonText className={styles.errorMessage}>
                          {printErrorMessage}
                        </IonText>
                      )}
                    </div>
                  )}
                  <div className={styles.operationsRefundContentRequest}>

                    <IonModal
                      isOpen={openRefundModal}
                      onDidDismiss={() => {
                        setOpenRefundModal(false);
                        setConfirmRefundError('');
                      }}
                      className={styles.modalRefund}
                    >
                      <IonHeader className={styles.infomodalHeaderRefund}>
                        <IonToolbar>
                          <IonButtons slot="end">
                            <IonButton
                              onClick={() => setOpenRefundModal(false)}
                            >
                              <IonIcon md={closeOutline} />
                            </IonButton>
                          </IonButtons>
                        </IonToolbar>
                      </IonHeader>
                      <IonContent>
                        {isLoading && (
                          <IonLoading
                            isOpen
                            spinner="circles"
                            className={styles.loading}
                          />
                        )}
                        <div className={styles.modalRefundInfoGeneral}>
                          <div className={styles.modalRefundInfoGeneralTitleData}>
                            <IonLabel className={styles.modalRefundInfoGeneralTitle}>
                              Resumen de la operación
                            </IonLabel>
                            <IonIcon
                              md={helpCircleOutline}
                              className={styles.modalRefundInfoGeneralTitleIcon}
                              onClick={() => setOpenSummaryModal(true)}
                            />
                            <IonModal
                              isOpen={openSummaryModal}
                              onDidDismiss={() => setOpenSummaryModal(false)}
                              className={classNames(styles.infoModalRefundSummary, { [styles.openSummaryModal]: openSummaryModal })}
                            >
                              <IonHeader className={styles.infomodalHeader}>
                                <IonToolbar>
                                  <IonButtons slot="end">
                                    <IonButton
                                      onClick={() => setOpenSummaryModal(false)}
                                    >
                                      <IonIcon md={closeOutline} />
                                    </IonButton>
                                  </IonButtons>
                                </IonToolbar>
                              </IonHeader>
                              <IonContent>
                                <div className={styles.itemTotalPartial}>
                                  <IonIcon
                                    md={helpCircleOutline}
                                    className={styles.itemTotalPartialIcon}
                                  />
                                  <IonLabel className={styles.itemTotalPartialTitle}>
                                    ¿Que significa cada punto?
                                  </IonLabel>
                                  <IonText className={styles.itemTotalPartialTextSummary}>
                                    Importe de la compra
                                  </IonText>
                                  <IonText className={styles.itemTotalPartialText}>
                                    Hace referencia al importe total adquirido
                                    por el cliente.
                                  </IonText>
                                  <IonText className={styles.itemTotalPartialTextSummary}>
                                    Numero de cuotas
                                  </IonText>
                                  <IonText className={styles.itemTotalPartialText}>
                                    Cantidad de cuotas totales de la
                                    financiación adquirida.
                                  </IonText>
                                  <IonText className={styles.itemTotalPartialTextSummary}>
                                    Importe de cuota
                                  </IonText>
                                  <IonText className={styles.itemTotalPartialText}>
                                    Importe mensual que debe pagar el cliente a
                                    la hora de adquirir la financiación.
                                  </IonText>
                                  <IonText className={styles.itemTotalPartialTextSummary}>
                                    Descuento
                                  </IonText>
                                  <IonText className={styles.itemTotalPartialText}>
                                    Tasa devengada por Pepper para realizar la
                                    financiación.
                                  </IonText>
                                  <IonText className={styles.itemTotalPartialTextSummary}>
                                    Gastos adicionales
                                  </IonText>
                                  <IonText className={styles.itemTotalPartialText}>
                                    Gastos referentes a la devolución del
                                    producto.
                                  </IonText>
                                  <IonText className={styles.itemTotalPartialTextSummary}>
                                    Descuento en próxima operación
                                  </IonText>
                                  <IonText className={styles.itemTotalPartialText}>
                                    Saldo a favor de Pepper, será compensado a
                                    medida que se realicen mas operaciones.
                                  </IonText>
                                </div>
                              </IonContent>
                            </IonModal>
                          </div>
                          <IonText className={styles.modalRefundInfoGeneralSubtitle}>
                            Comprueba que todo es correcto antes de realizar la
                            devolución.
                          </IonText>
                          <div className={styles.modalRefundContentTable}>
                            <IonGrid className={styles.contentModalTableGrid}>
                              <IonRow className={styles.contentModalTableGridrow}>
                                <IonCol className={styles.contentModalTableGridrowInfo}>
                                  Importe de la compra:
                                </IonCol>
                                <IonCol className={styles.contentModalTableGridrowAmount}>
                                  {pricesHelper(
                                    commercialOffer?.loan?.requested_amount,
                                  )}
                                </IonCol>
                              </IonRow>
                              {refundMethod === RefundType.Partial && (
                                <IonRow className={styles.contentModalTableGridrow}>
                                  <IonCol className={styles.contentModalTableGridrowInfo}>
                                    Importe de la devolución:
                                  </IonCol>
                                  <IonCol className={styles.contentModalTableGridrowAmount}>
                                    {amount != null
                                      ? pricesHelper(amount)
                                      : amount}
                                  </IonCol>
                                </IonRow>
                              )}
                              {/* <IonRow className="content-modal-table-gridrow">
                                <IonCol className="content-modal-table-gridrow-info">
                                  Número de cuotas:
                                </IonCol>
                                <IonCol className="content-modal-table-gridrow-amount">
                                  {commercialOffer?.loan?.term}
                                </IonCol>
                              </IonRow> */}
                              {/* <IonRow className="content-modal-table-gridrow">
                                <IonCol className="content-modal-table-gridrow-info">
                                  Importe de cuota:
                                </IonCol>
                                <IonCol className="content-modal-table-gridrow-amount">
                                  {pricesHelper(commercialOffer?.loan?.fee)}
                                </IonCol>
                              </IonRow> */}
                              <IonRow className={styles.contentModalTableGridrow}>
                                <IonCol className={styles.contentModalTableGridrowInfo}>
                                  Descuento:
                                </IonCol>
                                <IonCol className={styles.contentModalTableGridrowAmount}>
                                  {
                                    refundMethod === RefundType.Partial
                                      ? pricesHelper(
                                        refundData?.discount || 0.00,
                                      )
                                      : pricesHelper(
                                        totalRefund?.discount ?? 0,
                                        true,
                                      )
                                  }

                                </IonCol>
                              </IonRow>
                              {commercialOffer?.order && refundMethod === RefundType.Total && (
                              <IonRow className={styles.contentModalTableGridrow}>
                                <IonCol className={styles.contentModalTableGridrowInfo}>
                                  Gastos adicionales:
                                </IonCol>
                                <IonCol className={styles.contentModalTableGridrowAmount}>
                                  {refundMethod === RefundType.Total ? amount && pricesHelper(amount) : '0,00'}
                                </IonCol>
                              </IonRow>
                              )}
                            </IonGrid>
                          </div>
                          <div className={styles.modalResultTotal}>
                            <IonText className={styles.modalResultTotalDiscount}>
                              Descuento en próxima liquidación
                            </IonText>
                            <IonText className={styles.modalResultTotalAmount}>
                              {refundMethod === RefundType.Partial
                                ? refundData && pricesHelper(refundData?.balance)
                                : totalRefund && pricesHelper(
                                  commercialOffer?.loan?.requested_amount
                                  - totalRefund.discount
                                  - (amount ?? 0),
                                  true,
                                )}
                              {' '}
                            </IonText>
                          </div>
                          <div role="alert" className={styles.modalRefundError}>
                            {confirmRefundError}
                          </div>
                          <div className={styles.modalRefundButtons}>
                            <IonButton
                              ref={buttonRef}
                              className={styles.modalRefundButtonsConfirm}
                              id={refundMethod === RefundType.Total ? 'total' : 'partial'}
                              onClick={() => handleConfirmRefund()}
                            >
                              Confirmar devolución
                            </IonButton>

                            <IonButton
                              className={styles.modalRefundButtonsEdit}
                              onClick={() => setOpenRefundModal(false)}
                            >
                              Volver a editar
                            </IonButton>
                          </div>
                        </div>
                      </IonContent>
                    </IonModal>
                  </div>
                </div>
                {isDesktop
                  && (
                  <div className={styles.buttonRefundContainer}>
                    <Button
                      className={styles.buttonRefund}
                      id="button-refund"
                      onClick={() => setOpenRefundModal(true)}
                      disabled={
                        (refundMethod === RefundType.Partial && !amount)
                        || (refundMethod === RefundType.Total && unprocessable)
                        || printErrorMessage !== ''
                        || calculatingMaxRefund.current
                      }
                    >
                      Solicitar devolución
                    </Button>
                  </div>
                  )}
              </IonCardContent>
            </IonCard>
          </div>
        </div>
        <IonModal
          isOpen={openFinishModal}
          onDidDismiss={() => setOpenFinishModal(false)}
          className={styles.finishModal}
          id="bottom-modal-finish"
        >
          <IonHeader className={styles.infomodalHeaderRefundFinish}>
            <IonToolbar>
              <IonButtons slot="end">
                <IonButton onClick={() => setOpenFinishModal(false)}>
                  <IonIcon md={closeOutline} />
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent>
            <div className={styles.finishModalContent}>
              <IonImg src={Finish} className={styles.finishModalContentImg} />
              <IonLabel className={styles.finishModalContentTitle}>
                Devolución realizada.
              </IonLabel>
              <IonText className={styles.finishModalContentSubtitle}>
                ¡Enhorabuena! La devolución que acabas de solicitar en Pepper se
                ha procesado correctamente.
              </IonText>
              <IonButton
                className={styles.finishModalContentButton}
                onClick={() => {
                  setOpenFinishModal(false);
                  setTimeout(() => {
                    const destination = cartID
                      ? `${ROUTES_PATH.OPERATION_DASHBOARD_DETAIL}?cart_id=${cartID}`
                      : `${ROUTES_PATH.OPERATION_DASHBOARD_DETAIL}?credit_proposal_id=${creditProposalID}`;

                    const state = cartID
                      ? { cartIDState: cartID }
                      : { creditProposalIDState: creditProposalID };

                    history.push(destination, { state });
                    setAmount(null);
                    setRefundMethod(RefundType.Total);
                  }, 100);
                }}
              >
                Volver a la operación
              </IonButton>
            </div>
          </IonContent>
        </IonModal>
        {!isDesktop
          && (
          <div className={styles.operationsRefundContentButtonsMobile} id="contentButtonsMobile">
            <Button
              id="button-refund"
              onClick={() => setOpenRefundModal(true)}
              disabled={
                (refundMethod === RefundType.Partial && !amount)
                || (refundMethod === RefundType.Total && unprocessable)
                || printErrorMessage !== ''
              }
            >
              Solicitar devolución
            </Button>
          </div>
          )}
      </IonContent>
    </IonPage>
  );
}
